import React, { useEffect, useState } from "react";
import { resolveAppraisalAttachmentSecureViewUrl } from "pages/AppraisalManagment/utils/appraisalAttachmentHelpers";

const ObjectiveSnapsThumb = ({ attachment, label, className = "objective-snaps-thumb" }) => {
  const [src, setSrc] = useState(() => attachment?._previewUrl || "");
  const [href, setHref] = useState("");
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    if (attachment?._previewUrl) {
      setSrc(attachment._previewUrl);
      setHref(attachment._previewUrl);
      setLoadFailed(false);
      return () => {
        URL.revokeObjectURL(attachment._previewUrl);
      };
    }

    const viewUrl = resolveAppraisalAttachmentSecureViewUrl(attachment);
    if (viewUrl) {
      setSrc(viewUrl);
      setHref(viewUrl);
      setLoadFailed(false);
      return undefined;
    }

    setSrc("");
    setHref("");
    setLoadFailed(true);
    return undefined;
  }, [attachment]);

  const handleError = () => {
    setLoadFailed(true);
  };

  if (loadFailed) {
    return (
      <div className={`${className} objective-snaps-thumb--placeholder`}>
        Preview unavailable
      </div>
    );
  }

  if (!src) {
    return (
      <div className={`${className} objective-snaps-thumb--placeholder`}>Loading…</div>
    );
  }

  return (
    <a
      href={href || src}
      target="_blank"
      rel="noopener noreferrer"
      className="objective-snaps-thumb-link"
    >
      <img src={src} alt={label} className={className} onError={handleError} />
    </a>
  );
};

export default ObjectiveSnapsThumb;
